export const translations = {
  en: {
    nav: { fleet: "Fleet", destinations: "Destinations", experience: "Experience", contact: "Contact", book: "Book Now" },
    hero: {
      tag: "Private Airport Transfers · Cancun International",
      l1: "Arrive Like",
      l2: "Royalty in",
      l3: "the Riviera Maya",
      sub: "Private van transfers from Cancun Airport to every hotel, archaeological wonder and hidden cenote across Cancun & the Riviera Maya.",
      cta: "Book Your Transfer",
      secondary: "View Destinations",
    },
    marquee: ["Meet & Greet", "Private Van", "24/7 Service", "Fixed Rates", "Professional Chauffeurs", "Door to Door"],
    manifesto: {
      tag: "The HRH Standard",
      title: "A transfer, elevated to an experience.",
      chapters: [
        { n: "01", t: "The Fleet", d: "Immaculate private vans for up to 14 passengers. Climate controlled, spacious and discreet — your journey belongs to you alone." },
        { n: "02", t: "Meet & Greet", d: "Your professional chauffeur waits outside arrivals holding a sign with your name. No lines, no confusion, no waiting under the sun." },
        { n: "03", t: "Every Destination", d: "Hotels across the Hotel Zone and Riviera Maya, plus Chichen Itza, Tulum, Coba and the region's most iconic sites." },
        { n: "04", t: "Fixed, Fair Rates", d: "Transparent flat pricing per destination. What you see is what you pay — no surge, no surprises at the door." },
      ],
    },
    fleet: {
      tag: "The Vehicle",
      title: "The Private Van",
      d: "Every booking rides in a private, air-conditioned van reserved exclusively for your party. Room for luggage, families and groups of up to 14 — in complete comfort.",
      features: ["Up to 14 passengers", "Air conditioning", "Bottled water", "Free child seats on request", "Professional driver", "24/7 availability"],
    },
    destinations: { tag: "Where To?", title: "Destinations & Rates", sub: "Per-person transfer rates. Private full-day tours to the ruins. Round trips available at checkout.", from: "from", book: "Book", perVan: "per private van", perPerson: "per person", privateTour: "private tour" },
    inc: { title: "Included in this private tour", guide: "Certified private guide", tickets: "Entrance tickets", meal: "Lunch included" },
    cta: { title: "Ready when you land.", sub: "Reserve in under two minutes.", btn: "Book Now" },
    footer: { tagline: "Private ground transportation across Cancun & the Riviera Maya.", quick: "Explore", legal: "Legal", contact: "Contact", terms: "Terms & Conditions", privacy: "Privacy Policy", rights: "All rights reserved." },
    booking: {
      title: "Reserve Your Transfer",
      sub: "Private van · Meet & greet included",
      tripType: "Trip Type",
      oneWay: "One Way",
      roundTrip: "Round Trip",
      destination: "Destination",
      searchPh: "Search hotel, zone or site…",
      passengers: "Passengers",
      arrival: "Arrival Flight (Airport → Hotel)",
      departure: "Departure Flight (Hotel → Airport)",
      airline: "Airline",
      flightNo: "Flight number",
      date: "Date",
      time: "Time",
      yourDetails: "Your Details",
      name: "Full name",
      email: "Email",
      phone: "Phone / WhatsApp",
      hotel: "Hotel / accommodation name",
      notes: "Notes (optional)",
      summary: "Booking Summary",
      vehicle: "Vehicle",
      privateVan: "Private Van",
      perPerson: "per person",
      privateTour: "private tour",
      subtotal: "Subtotal",
      meet: "Your driver will be waiting outside with a sign.",
      total: "Total",
      submit: "Confirm Reservation",
      pay: "Pay Now with Mercado Pago",
      selectDest: "Please select a destination.",
      success: "Reservation received! We've sent the details to our team. Proceed to payment or we'll contact you shortly.",
    },
    contact: { title: "Talk to an Agent", sub: "Our concierge team replies within a few hours.", name: "Full name", email: "Email", phone: "Phone", message: "How can we help?", submit: "Send Message", success: "Message sent. We'll be in touch shortly.", or: "Or reach us directly" },
    admin: { login: "Admin Login", email: "Email", password: "Password", signin: "Sign In", dashboard: "Dashboard", bookings: "Bookings", contacts: "Contacts", destinationsTab: "Destinations", logout: "Logout" },
    payment: { successT: "Payment Approved", successD: "Thank you — your transfer is confirmed. A driver will meet you with a sign.", failT: "Payment Failed", failD: "Your payment could not be processed. Please try again.", pendT: "Payment Pending", pendD: "Your payment is being processed. We'll confirm shortly.", home: "Back to Home" },
  },
  es: {
    nav: { fleet: "Flota", destinations: "Destinos", experience: "Experiencia", contact: "Contacto", book: "Reservar" },
    hero: {
      tag: "Traslados Privados · Aeropuerto de Cancún",
      l1: "Llega Como",
      l2: "Realeza a",
      l3: "la Riviera Maya",
      sub: "Traslados en van privada desde el Aeropuerto de Cancún a todos los hoteles, zonas arqueológicas y cenotes de Cancún y la Riviera Maya.",
      cta: "Reserva tu Traslado",
      secondary: "Ver Destinos",
    },
    marquee: ["Recepción con Cartel", "Van Privada", "Servicio 24/7", "Tarifas Fijas", "Choferes Profesionales", "Puerta a Puerta"],
    manifesto: {
      tag: "El Estándar HRH",
      title: "Un traslado, elevado a experiencia.",
      chapters: [
        { n: "01", t: "La Flota", d: "Vans privadas impecables para hasta 14 pasajeros. Con clima, espaciosas y discretas — el viaje es solo tuyo." },
        { n: "02", t: "Recepción", d: "Tu chofer profesional te espera afuera de llegadas con un cartel con tu nombre. Sin filas, sin confusiones, sin esperar bajo el sol." },
        { n: "03", t: "Todo Destino", d: "Hoteles en la Zona Hotelera y Riviera Maya, además de Chichén Itzá, Tulum, Cobá y los sitios más icónicos de la región." },
        { n: "04", t: "Tarifas Justas", d: "Precio plano y transparente por destino. Lo que ves es lo que pagas — sin sorpresas." },
      ],
    },
    fleet: {
      tag: "El Vehículo",
      title: "La Van Privada",
      d: "Cada reserva viaja en una van privada con aire acondicionado, reservada en exclusiva para tu grupo. Espacio para equipaje, familias y grupos de hasta 14 personas.",
      features: ["Hasta 14 pasajeros", "Aire acondicionado", "Agua embotellada", "Sillas para niños a pedido", "Chofer profesional", "Disponible 24/7"],
    },
    destinations: { tag: "¿A Dónde?", title: "Destinos y Tarifas", sub: "Tarifas de traslado por persona. Tours privados de día completo a las ruinas. Viaje redondo disponible al pagar.", from: "desde", book: "Reservar", perVan: "por van privada", perPerson: "por persona", privateTour: "tour privado" },
    inc: { title: "Incluido en este tour privado", guide: "Guía privado certificado", tickets: "Entradas incluidas", meal: "Comida incluida" },
    cta: { title: "Listos cuando aterrices.", sub: "Reserva en menos de dos minutos.", btn: "Reservar Ahora" },
    footer: { tagline: "Transportación terrestre privada en Cancún y la Riviera Maya.", quick: "Explorar", legal: "Legal", contact: "Contacto", terms: "Términos y Condiciones", privacy: "Aviso de Privacidad", rights: "Todos los derechos reservados." },
    booking: {
      title: "Reserva tu Traslado",
      sub: "Van privada · Recepción incluida",
      tripType: "Tipo de Viaje",
      oneWay: "Sencillo",
      roundTrip: "Redondo",
      destination: "Destino",
      searchPh: "Busca hotel, zona o sitio…",
      passengers: "Pasajeros",
      arrival: "Vuelo de Llegada (Aeropuerto → Hotel)",
      departure: "Vuelo de Salida (Hotel → Aeropuerto)",
      airline: "Aerolínea",
      flightNo: "Número de vuelo",
      date: "Fecha",
      time: "Hora",
      yourDetails: "Tus Datos",
      name: "Nombre completo",
      email: "Correo",
      phone: "Teléfono / WhatsApp",
      hotel: "Nombre del hotel / hospedaje",
      notes: "Notas (opcional)",
      summary: "Resumen de Reserva",
      vehicle: "Vehículo",
      privateVan: "Van Privada",
      perPerson: "por persona",
      privateTour: "tour privado",
      subtotal: "Subtotal",
      meet: "Tu chofer te esperará afuera con un cartel.",
      total: "Total",
      submit: "Confirmar Reserva",
      pay: "Pagar con Mercado Pago",
      selectDest: "Por favor selecciona un destino.",
      success: "¡Reserva recibida! Enviamos los detalles a nuestro equipo. Continúa al pago o te contactaremos pronto.",
    },
    contact: { title: "Habla con un Agente", sub: "Nuestro equipo responde en pocas horas.", name: "Nombre completo", email: "Correo", phone: "Teléfono", message: "¿Cómo podemos ayudarte?", submit: "Enviar Mensaje", success: "Mensaje enviado. Te contactaremos pronto.", or: "O contáctanos directamente" },
    admin: { login: "Acceso Admin", email: "Correo", password: "Contraseña", signin: "Ingresar", dashboard: "Panel", bookings: "Reservas", contacts: "Contactos", destinationsTab: "Destinos", logout: "Salir" },
    payment: { successT: "Pago Aprobado", successD: "Gracias — tu traslado está confirmado. Un chofer te recibirá con un cartel.", failT: "Pago Fallido", failD: "No pudimos procesar tu pago. Intenta de nuevo.", pendT: "Pago Pendiente", pendD: "Tu pago se está procesando. Confirmaremos pronto.", home: "Volver al Inicio" },
  },
  pt: {
    nav: { fleet: "Frota", destinations: "Destinos", experience: "Experiência", contact: "Contato", book: "Reservar" },
    hero: {
      tag: "Traslados Privados · Aeroporto de Cancún",
      l1: "Chegue Como",
      l2: "Realeza à",
      l3: "Riviera Maya",
      sub: "Traslados em van privada do Aeroporto de Cancún para todos os hotéis, zonas arqueológicas e cenotes de Cancún e da Riviera Maya.",
      cta: "Reserve seu Traslado",
      secondary: "Ver Destinos",
    },
    marquee: ["Recepção com Placa", "Van Privada", "Serviço 24/7", "Tarifas Fixas", "Motoristas Profissionais", "Porta a Porta"],
    manifesto: {
      tag: "O Padrão HRH",
      title: "Um traslado elevado a experiência.",
      chapters: [
        { n: "01", t: "A Frota", d: "Vans privadas impecáveis para até 14 passageiros. Com ar-condicionado, espaçosas e discretas — a viagem é só sua." },
        { n: "02", t: "Recepção", d: "Seu motorista profissional espera na saída com uma placa com seu nome. Sem filas, sem confusão, sem esperar no sol." },
        { n: "03", t: "Todo Destino", d: "Hotéis na Zona Hoteleira e Riviera Maya, além de Chichén Itzá, Tulum, Cobá e os locais mais icônicos da região." },
        { n: "04", t: "Tarifas Justas", d: "Preço fixo e transparente por destino. O que você vê é o que paga — sem surpresas." },
      ],
    },
    fleet: {
      tag: "O Veículo",
      title: "A Van Privada",
      d: "Cada reserva viaja em uma van privada com ar-condicionado, reservada exclusivamente para o seu grupo. Espaço para bagagem, famílias e grupos de até 14 pessoas.",
      features: ["Até 14 passageiros", "Ar-condicionado", "Água mineral", "Cadeirinhas sob pedido", "Motorista profissional", "Disponível 24/7"],
    },
    destinations: { tag: "Para Onde?", title: "Destinos e Tarifas", sub: "Tarifas de traslado por pessoa. Tours privados de dia inteiro às ruínas. Ida e volta disponível no pagamento.", from: "a partir de", book: "Reservar", perVan: "por van privada", perPerson: "por pessoa", privateTour: "tour privado" },
    inc: { title: "Incluído neste tour privado", guide: "Guia privado certificado", tickets: "Ingressos incluídos", meal: "Almoço incluído" },
    cta: { title: "Prontos quando você pousar.", sub: "Reserve em menos de dois minutos.", btn: "Reservar Agora" },
    footer: { tagline: "Transporte terrestre privado em Cancún e na Riviera Maya.", quick: "Explorar", legal: "Legal", contact: "Contato", terms: "Termos e Condições", privacy: "Política de Privacidade", rights: "Todos os direitos reservados." },
    booking: {
      title: "Reserve seu Traslado",
      sub: "Van privada · Recepção incluída",
      tripType: "Tipo de Viagem",
      oneWay: "Somente Ida",
      roundTrip: "Ida e Volta",
      destination: "Destino",
      searchPh: "Busque hotel, zona ou local…",
      passengers: "Passageiros",
      arrival: "Voo de Chegada (Aeroporto → Hotel)",
      departure: "Voo de Partida (Hotel → Aeroporto)",
      airline: "Companhia aérea",
      flightNo: "Número do voo",
      date: "Data",
      time: "Hora",
      yourDetails: "Seus Dados",
      name: "Nome completo",
      email: "E-mail",
      phone: "Telefone / WhatsApp",
      hotel: "Nome do hotel / hospedagem",
      notes: "Observações (opcional)",
      summary: "Resumo da Reserva",
      vehicle: "Veículo",
      privateVan: "Van Privada",
      perPerson: "por pessoa",
      privateTour: "tour privado",
      subtotal: "Subtotal",
      meet: "Seu motorista estará esperando com uma placa.",
      total: "Total",
      submit: "Confirmar Reserva",
      pay: "Pagar com Mercado Pago",
      selectDest: "Por favor selecione um destino.",
      success: "Reserva recebida! Enviamos os detalhes à nossa equipe. Prossiga ao pagamento ou entraremos em contato em breve.",
    },
    contact: { title: "Fale com um Agente", sub: "Nossa equipe responde em poucas horas.", name: "Nome completo", email: "E-mail", phone: "Telefone", message: "Como podemos ajudar?", submit: "Enviar Mensagem", success: "Mensagem enviada. Entraremos em contato em breve.", or: "Ou fale conosco diretamente" },
    admin: { login: "Acesso Admin", email: "E-mail", password: "Senha", signin: "Entrar", dashboard: "Painel", bookings: "Reservas", contacts: "Contatos", destinationsTab: "Destinos", logout: "Sair" },
    payment: { successT: "Pagamento Aprovado", successD: "Obrigado — seu traslado está confirmado. Um motorista o receberá com uma placa.", failT: "Pagamento Falhou", failD: "Não foi possível processar seu pagamento. Tente novamente.", pendT: "Pagamento Pendente", pendD: "Seu pagamento está sendo processado. Confirmaremos em breve.", home: "Voltar ao Início" },
  },
};

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "pt", label: "PT" },
];
